// OrderManagement.jsx
import React from "react";
import { Alert, Snackbar } from "@mui/material";
import OrderManagementHeader from "./orderManagement/OrderManagementHeader";
import OrderCardList from "./orderManagement/OrderCardList";
import OrderDialog from "./orderManagement/OrderDialog";
import PerformanceDialog from "./orderManagement/PerformanceDialog";
import MaterialDialog from "./orderManagement/MaterialDialog";
import NewArticleDialog from "./orderManagement/NewArticleDialog";
import InvoiceDialog from "./orderManagement/InvoiceDialog";
import useOrderManagement from "./orderManagement/useOrderManagement";

export default function OrderManagement() {
    const {
        orders,
        loadingOrders,
        savingOrder,
        deletingOrder,
        orderErrors,
        performanceErrors,
        materialErrors,
        performanceEntryErrors,
        materialEntryErrors,
        newArticleErrors,
        openDialog,
        editingIndex,
        currentOrder,
        openPerformanceDialog,
        editingPerformanceIndex,
        currentPerformance,
        openMaterialDialog,
        editingMaterialIndex,
        currentMaterial,
        articles,
        loadingArticles,
        loadingCustomers,
        openNewArticleDialog,
        newArticle,
        invoiceDialogOpen,
        invoiceOrder,
        invoiceSelections,
        snack,
        setSnack,
        customerOptions,
        selectedCustomerOption,
        handleDialogOpen,
        handleDialogClose,
        handleOrderFieldChange,
        handleCustomerChange,
        handlePerformanceFieldChange,
        handlePerformanceArticleChange,
        handleMaterialFieldChange,
        handleMaterialArticleChange,
        handleNewArticleFieldChange,
        handleSaveOrder,
        handleEditOrder,
        handleDeleteOrder,
        handleOpenPerformanceDialog,
        handleClosePerformanceDialog,
        handleEditPerformance,
        handleSavePerformance,
        handleRemovePerformance,
        handleOpenMaterialDialog,
        handleCloseMaterialDialog,
        handleEditMaterial,
        handleSaveMaterial,
        handleRemoveMaterial,
        handleOpenNewArticleDialog,
        handleCloseNewArticleDialog,
        handleSaveNewArticle,
        handleCreateInvoiceFromOrder,
        handleCloseInvoiceDialog,
        toggleInvoiceSelection,
        toggleAllInvoiceSelections,
        handleConfirmInvoiceSelection,
        fetchOrders,
        fetchArticles,
        resolveCustomerLabel,
        orderTotals,
        resolveInvoiceStatus,
        selectablePerformanceCount,
        selectableMaterialCount,
        allPerformanceSelected,
        somePerformanceSelected,
        allMaterialSelected,
        someMaterialSelected,
        hasInvoiceSelections,
        getCustomerOptionLabel,
        isCustomerOptionEqualToValue,
    } = useOrderManagement();

    return (
        <>
            <OrderManagementHeader
                onRefreshOrders={fetchOrders}
                onRefreshArticles={fetchArticles}
                onCreateOrder={handleDialogOpen}
            />

            <OrderCardList
                orders={orders}
                loadingOrders={loadingOrders}
                loadingArticles={loadingArticles}
                deletingOrder={deletingOrder}
                onEditOrder={handleEditOrder}
                onDeleteOrder={handleDeleteOrder}
                onCreateInvoice={handleCreateInvoiceFromOrder}
                onCreateFirstOrder={handleDialogOpen}
                orderTotals={orderTotals}
                resolveInvoiceStatus={resolveInvoiceStatus}
                resolveCustomerLabel={resolveCustomerLabel}
            />

            <OrderDialog
                open={openDialog}
                editingIndex={editingIndex}
                currentOrder={currentOrder}
                orderErrors={orderErrors}
                performanceEntryErrors={performanceEntryErrors}
                materialEntryErrors={materialEntryErrors}
                customerOptions={customerOptions}
                loadingCustomers={loadingCustomers}
                selectedCustomerOption={selectedCustomerOption}
                onCustomerChange={handleCustomerChange}
                getCustomerOptionLabel={getCustomerOptionLabel}
                isCustomerOptionEqualToValue={isCustomerOptionEqualToValue}
                onOrderFieldChange={handleOrderFieldChange}
                onOpenPerformanceDialog={handleOpenPerformanceDialog}
                onEditPerformance={handleEditPerformance}
                onRemovePerformance={handleRemovePerformance}
                onOpenMaterialDialog={handleOpenMaterialDialog}
                onEditMaterial={handleEditMaterial}
                onRemoveMaterial={handleRemoveMaterial}
                onClose={handleDialogClose}
                onSave={handleSaveOrder}
                savingOrder={savingOrder}
            />

            <PerformanceDialog
                open={openPerformanceDialog}
                editingPerformanceIndex={editingPerformanceIndex}
                currentPerformance={currentPerformance}
                performanceErrors={performanceErrors}
                articles={articles}
                onClose={handleClosePerformanceDialog}
                onSave={handleSavePerformance}
                onFieldChange={handlePerformanceFieldChange}
                onArticleChange={handlePerformanceArticleChange}
            />

            <MaterialDialog
                open={openMaterialDialog}
                editingMaterialIndex={editingMaterialIndex}
                currentMaterial={currentMaterial}
                materialErrors={materialErrors}
                articles={articles}
                onClose={handleCloseMaterialDialog}
                onSave={handleSaveMaterial}
                onFieldChange={handleMaterialFieldChange}
                onArticleChange={handleMaterialArticleChange}
                onOpenNewArticle={handleOpenNewArticleDialog}
            />

            <NewArticleDialog
                open={openNewArticleDialog}
                newArticle={newArticle}
                newArticleErrors={newArticleErrors}
                onClose={handleCloseNewArticleDialog}
                onSave={handleSaveNewArticle}
                onFieldChange={handleNewArticleFieldChange}
            />

            <InvoiceDialog
                open={invoiceDialogOpen}
                invoiceOrder={invoiceOrder}
                invoiceSelections={invoiceSelections}
                selectablePerformanceCount={selectablePerformanceCount}
                selectableMaterialCount={selectableMaterialCount}
                allPerformanceSelected={allPerformanceSelected}
                somePerformanceSelected={somePerformanceSelected}
                allMaterialSelected={allMaterialSelected}
                someMaterialSelected={someMaterialSelected}
                hasInvoiceSelections={hasInvoiceSelections}
                onClose={handleCloseInvoiceDialog}
                onToggleSelection={toggleInvoiceSelection}
                onToggleAll={toggleAllInvoiceSelections}
                onConfirm={handleConfirmInvoiceSelection}
                resolveCustomerLabel={resolveCustomerLabel}
            />

            <Snackbar
                open={snack.open}
                autoHideDuration={3500}
                onClose={() => setSnack((s) => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert
                    onClose={() => setSnack((s) => ({ ...s, open: false }))}
                    severity={snack.sev}
                    sx={{ width: "100%" }}
                >
                    {snack.msg}
                </Alert>
            </Snackbar>
        </>
    );
}
